import { useMutation } from "@tanstack/react-query";

import { queryClient } from "../../../config/react-query";
import { useToast } from "../../../hooks/useToast";
import { stockFolder } from "./actions";

export function useStockFolder() {
    const { successToast } = useToast();

    const mutation = useMutation({
        mutationFn: stockFolder,
        onSuccess: () => successToast("Le dossier a bien été ajouté au dépôt"),
        onSettled: () => {
            queryClient.invalidateQueries({
                queryKey: ["folders"],
            });
        },
    });

    return mutation;
}
